module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "loading": _vm.loading,
      "clearable": _vm.clearable,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "disabled": item.disabled
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3724903b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/CorpSelect.vue
// module id = 323
// module chunks = 0